const EmptyIcon = ({ w = 300, h = 300 }) => {
  return (
    <svg
      width={w}
      height={h}
      viewBox="0 0 300 300"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M298.752 256.684C305.987 242.365 285.308 170.769 141.923 170.769C38.4274 170.769 -9.07413 229.372 1.42751 259.07"
        fill="url(#paint0_radial_1720_8548)"
      />
      <mask
        id="mask0_1720_8548"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x={0}
        y={170}
        width={300}
        height={90}
      >
        <path
          d="M298.752 256.684C305.987 242.365 285.308 170.769 141.923 170.769C38.4274 170.769 -9.07413 229.372 1.42751 259.07"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_1720_8548)">
        <ellipse
          opacity="0.671968"
          cx="119.807"
          cy="233.995"
          rx="7.88551"
          ry="4.38001"
          fill="url(#paint1_linear_1720_8548)"
        />
        <ellipse
          opacity="0.256348"
          cx="200.293"
          cy="204.233"
          rx="12.4416"
          ry="6.83282"
          fill="url(#paint2_linear_1720_8548)"
        />
        <ellipse
          opacity="0.729957"
          cx="58.7033"
          cy="186.011"
          rx="12.4416"
          ry="6.83282"
          fill="url(#paint3_linear_1720_8548)"
        />
      </g>
      <path
        opacity="0.5"
        d="M116.885 186.647C116.885 186.647 147.396 200.994 159.5 206.5C169.088 210.861 218.456 224.813 224.338 220.847C230.219 216.881 243.204 205.997 238.917 198.54C234.63 191.083 212.085 177.694 201.302 175.737C190.52 173.781 159.688 182.674 159.688 182.674L133.39 187.19L116.885 186.647Z"
        fill="url(#paint4_linear_1720_8548)"
      />
      <path
        d="M139.5 122.5L105.5 147.5L114.565 126.231L148.615 104.614L139.5 122.5Z"
        fill="#E2E7EC"
      />
      <path d="M114 126.67L148.615 105V164.099L116.885 186.346L114 126.67Z" fill="#D8DFE6" />
      <path d="M148.615 105L201.692 117.417V176.538L148.615 164.121V105Z" fill="#E9EFF1" />
      <path d="M114 126.667L168.231 139.34V198.461L116.885 186.671L114 126.667Z" fill="#E8EAEB" />
      <path d="M167.076 139.362L201.692 117.692V176.792L167.076 198.462V139.362Z" fill="#D8DFE6" />
      <mask
        id="mask1_1720_8548"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x={167}
        y={117}
        width={35}
        height={82}
      >
        <path d="M167.076 139.362L201.692 117.692V176.792L167.076 198.462V139.362Z" fill="white" />
      </mask>
      <g mask="url(#mask1_1720_8548)">
        <rect x="179.934" y="112.768" width="10.8791" height="90.6191" fill="#C7D0D9" />
      </g>
      <path
        d="M182.642 156.923L216.692 135.306L201.126 117.692L167.076 139.309L182.642 156.923Z"
        fill="#E2E7EC"
      />
      <path
        opacity="0.5"
        d="M87.4466 188.137L141 215.501L146 201.001L93.4557 183.522L87.4466 188.137Z"
        fill="url(#paint5_linear_1720_8548)"
      />
      <path
        d="M85.9846 143.154L104.451 144.61L100.35 184.778C100.35 184.778 99.991 185.179 99.1198 185.023C98.2485 184.868 97.3345 184.383 97.3345 184.383L94.5881 152.45C94.5881 152.45 92.9997 163.742 93.1106 166.918C93.1942 169.312 94.0125 172.232 94.4505 174.729C94.8274 176.878 95.6205 182.015 95.6205 182.015C95.6205 182.015 94.6835 182.443 94.1851 182.539C93.6867 182.636 93.0477 182.105 93.0477 182.105C93.0477 182.105 86.5732 169.537 86.4899 167.15C86.4065 164.763 85.9846 143.154 85.9846 143.154Z"
        fill="url(#paint6_linear_1720_8548)"
      />
      <path
        d="M92.761 182.046C92.761 182.046 91.9385 183.527 90.9168 184.43C89.895 185.333 87.8788 186.411 87.4192 186.901C86.9595 187.391 87.4615 188.113 87.4615 188.113L92.403 187.94L96.3515 184.6L95.7998 181.416L92.761 182.046Z"
        fill="#677285"
      />
      <path
        d="M100.815 183.761L101.969 186.96C101.969 186.96 100.074 188.428 97.4568 188.836C94.8393 189.244 93.0358 188.617 93.0358 188.617C93.0358 188.617 92.5631 187.665 93.4539 187.258C93.863 187.071 94.7799 186.294 95.5849 185.299C95.9483 184.85 97.3173 183.883 97.3173 183.883L100.815 183.761Z"
        fill="#677285"
      />
      <path
        d="M109.088 122.213C109.088 122.213 110.601 124.515 111.529 123.899C112.457 123.283 118.251 117.344 118.251 117.344C118.251 117.344 119.975 116.018 120.293 116.333C120.612 116.648 119.719 117.344 119.719 117.344C119.719 117.344 121.599 117.529 122.187 117.529C122.774 117.529 124.01 118.467 123.202 118.783C122.394 119.099 119.259 119.177 119.259 119.177C119.259 119.177 114.499 128.178 112.019 128.816C109.538 129.455 106.121 125.845 106.121 125.845L109.088 122.213Z"
        fill="#FDE7E6"
      />
      <path
        d="M84.9043 122.378C84.9043 122.378 83.9119 124.41 83.0126 123.922C82.1133 123.435 77.0676 118.113 77.0676 118.113C77.0676 118.113 75.3872 117.084 74.9763 117.269C74.5654 117.455 75.5784 118.113 75.5784 118.113C75.5784 118.113 73.1062 118.314 72.6411 118.501C72.1761 118.688 71.6344 119.261 72.3375 119.522C73.0407 119.782 75.7324 119.968 75.7324 119.968C75.7324 119.968 79.4742 127.362 82.3092 128.226C85.1442 129.091 87.5594 125.684 87.5594 125.684L84.9043 122.378Z"
        fill="#FDE7E6"
      />
      <path
        d="M94.0826 116.155V112.522C94.0826 112.522 92.1991 112.617 91.4334 111.356C90.6677 110.095 90.4609 106.515 90.4609 106.515L91.0379 104.856L96.7112 104.616L99.6917 107.156L98.304 109.607L98.0394 110.078L99.3622 115.649L94.0826 116.155Z"
        fill="#FDE7E6"
      />
      <mask
        id="mask2_1720_8548"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x={90}
        y={104}
        width={10}
        height={13}
      >
        <path
          d="M94.0826 116.155V112.522C94.0826 112.522 92.1991 112.617 91.4334 111.356C90.6677 110.095 90.4609 106.515 90.4609 106.515L91.0379 104.856L96.7112 104.616L99.6917 107.156L98.304 109.607L98.0394 110.078L99.3622 115.649L94.0826 116.155Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask2_1720_8548)">
        <path
          d="M97.7735 109.07C96.0968 111.155 93.1969 112.612 92.8193 112.612C92.4417 112.612 94.9279 115.228 94.9279 115.228L96.9506 116.155L99.8216 115.546L100.846 112.612L99.0372 109.284C99.0372 109.284 99.4501 106.985 97.7735 109.07Z"
          fill="url(#paint7_linear_1720_8548)"
        />
      </g>
      <path
        d="M83.6992 123.837L86.4872 127.593L88.2653 125.715C88.2653 125.715 86.9129 133.13 86.4872 136.686C86.0614 140.242 85.9823 143.784 85.9823 143.784C85.9823 143.784 90.4465 145.441 93.7743 145.72C97.1022 145.999 104.849 145.281 104.849 145.281L103.849 124.409L106.751 127.103L110.158 123.169C110.158 123.169 104.293 114.156 103.184 113.631C102.075 113.106 98.9918 113.631 98.9918 113.631C98.9918 113.631 96.804 116.22 95.9168 116.256C95.0297 116.292 93.0618 113.631 93.0618 113.631C93.0618 113.631 89.9177 113.129 89.0036 114.156C88.0894 115.183 83.6992 123.837 83.6992 123.837Z"
        fill="url(#paint8_linear_1720_8548)"
      />
      <path
        d="M90.4618 106.556C90.4618 106.556 91.1304 104.869 92.0032 105.163C92.8291 105.441 93.5445 106.103 94.5721 106.414C95.5996 106.724 95.7132 105.328 96.4114 105.564C97.1097 105.8 96.6488 107.853 97.141 108.236C97.6331 108.618 97.6331 105.564 98.6823 106.386C99.7315 107.208 97.5877 109.523 97.5877 109.523C97.5877 109.523 97.8625 110.945 97.9506 111.042C98.0387 111.139 98.0287 110.007 98.0287 110.007C98.0287 110.007 99.0307 109.622 99.4577 107.887C99.8847 106.153 100.069 105.462 99.4577 104.201C98.8461 102.941 98.6717 101.954 97.141 101.359C95.6102 100.764 94.4487 100.997 93.3789 101.359C92.309 101.721 91.5336 102.44 91.0388 103.156C89.8849 104.856 90.4618 106.556 90.4618 106.556Z"
        fill="#4D364F"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M193.616 62.06C192.4 62.4317 167.229 77.492 167.229 77.492L174.575 78.0397L179.794 83.8085C179.794 83.8085 194.832 61.6884 193.616 62.06Z"
        fill="#E8EAEB"
      />
      <mask
        id="mask3_1720_8548"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x={167}
        y={62}
        width={27}
        height={22}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M193.616 62.06C192.4 62.4317 167.229 77.492 167.229 77.492L174.575 78.0397L179.794 83.8085C179.794 83.8085 194.832 61.6884 193.616 62.06Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask3_1720_8548)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M174.575 78.0396L193.616 62.0599L179.794 83.8084L174.575 78.0396Z"
          fill="#D8DFE6"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M189.836 79.5113L181.009 78.5888L193.626 62.2155L189.836 79.5113Z"
        fill="#E8EAEB"
      />
      <path
        d="M155.728 135.1C155.043 135.538 154.343 135.978 153.628 136.419L153.104 135.567C153.814 135.13 154.509 134.694 155.188 134.259L155.728 135.1ZM162.373 130.519C161.334 131.296 160.245 132.077 159.105 132.861L158.539 132.038C159.668 131.261 160.747 130.488 161.774 129.719L162.373 130.519ZM168.592 125.351C167.65 126.234 166.64 127.121 165.563 128.012L164.926 127.242C165.987 126.363 166.981 125.49 167.907 124.622L168.592 125.351ZM173.983 119.377C173.222 120.413 172.363 121.457 171.407 122.506L170.668 121.832C171.601 120.808 172.438 119.792 173.178 118.785L173.983 119.377ZM147.64 113.291C148.739 114.177 149.857 114.759 150.995 115.039L150.756 116.01C149.469 115.693 148.221 115.044 147.012 114.069L147.64 113.291ZM177.748 112.123C177.375 113.376 176.852 114.639 176.179 115.91L175.295 115.441C175.938 114.227 176.437 113.026 176.79 111.838L177.748 112.123ZM158.688 113.998C157.432 114.898 156.194 115.528 154.973 115.885L154.691 114.927C155.798 114.603 156.937 114.023 158.105 113.185L158.688 113.998ZM164.401 108.219C163.512 109.368 162.632 110.394 161.763 111.296L161.043 110.601C161.886 109.727 162.742 108.728 163.61 107.606L164.401 108.219ZM142.996 107.121C143.369 108.092 143.954 109.12 144.759 110.204C144.821 110.287 144.882 110.369 144.944 110.45L144.149 111.057C144.085 110.973 144.02 110.887 143.956 110.801C143.099 109.647 142.47 108.54 142.062 107.479L142.996 107.121ZM177.815 103.906C178.096 104.558 178.276 105.24 178.352 105.947C178.425 106.636 178.45 107.328 178.428 108.023L177.429 107.991C177.45 107.342 177.426 106.696 177.357 106.053C177.292 105.446 177.138 104.862 176.896 104.302L177.815 103.906ZM168.893 101.513C168.174 102.725 167.461 103.863 166.755 104.925L165.922 104.372C166.618 103.325 167.322 102.202 168.032 101.004L168.893 101.513ZM144.705 100.391C143.625 101.284 142.93 102.307 142.646 103.45L141.676 103.209C142.014 101.846 142.83 100.642 144.067 99.6199L144.705 100.391ZM171.606 98.3933C172.97 99.0077 174.159 99.7202 175.145 100.522L174.514 101.298C173.599 100.554 172.483 99.8859 171.195 99.3054L171.606 98.3933ZM151.808 97.4441C150.436 97.7146 149.17 98.0731 148.045 98.5125L147.682 97.5808C148.865 97.1189 150.186 96.7441 151.614 96.4626L151.808 97.4441ZM172.729 94.4558C172.105 95.6957 171.485 96.8828 170.871 98.0164L169.992 97.5398C170.602 96.4154 171.217 95.2376 171.836 94.0066L172.729 94.4558ZM163.758 96.2322C165.137 96.4285 166.473 96.6977 167.737 97.0359L167.479 98.0017C166.255 97.674 164.958 97.4132 163.617 97.2224L163.758 96.2322ZM159.672 95.8718L159.637 96.8718C158.306 96.8245 156.981 96.8463 155.689 96.9373L155.619 95.9392C156.946 95.8458 158.307 95.8233 159.672 95.8718ZM176.162 87.2039C175.6 88.459 175.043 89.674 174.488 90.8474L173.584 90.4197C174.135 89.2526 174.691 88.0446 175.25 86.7957L176.162 87.2039Z"
        fill="#C7D0D9"
      />
      <defs>
        <radialGradient
          id="paint0_radial_1720_8548"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(130.111 201.392) rotate(-90) scale(51.3403 536.198)"
        >
          <stop stopColor="#EBEDF0" stopOpacity="0.24" />
          <stop offset="0.536775" stopColor="#EBEDF0" stopOpacity="0.845525" />
          <stop offset={1} stopColor="#E0E4E7" stopOpacity="0.01" />
        </radialGradient>
        <linearGradient
          id="paint1_linear_1720_8548"
          x1="113.46"
          y1="232.834"
          x2="115.863"
          y2="237.972"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E1E7EA" />
          <stop offset={1} stopColor="#D0D6DC" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_1720_8548"
          x1="189.846"
          y1="203.594"
          x2="194.242"
          y2="212.763"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E1E7EA" />
          <stop offset={1} stopColor="#D0D6DC" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_1720_8548"
          x1="50.7703"
          y1="186.122"
          x2="53.2577"
          y2="196.031"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FBFBFB" />
          <stop offset={1} stopColor="#D9DFE3" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_1720_8548"
          x1="112.401"
          y1="191.622"
          x2="121.277"
          y2="231.424"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C4CDD1" />
          <stop offset={1} stopColor="#C6CFD3" stopOpacity="0.01" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_1720_8548"
          x1="85.5883"
          y1="195.629"
          x2="95.8841"
          y2="222.499"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C4CDD1" />
          <stop offset={1} stopColor="#C6CFD3" stopOpacity="0.01" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_1720_8548"
          x1="105.786"
          y1="184.851"
          x2="104.318"
          y2="142.832"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#A1A7B8" />
          <stop offset={1} stopColor="#7B8195" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_1720_8548"
          x1="98.568"
          y1="113.716"
          x2="98.568"
          y2="110.196"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FBD8D6" />
          <stop offset={1} stopColor="#EAC0BE" stopOpacity="0.7" />
        </linearGradient>
        <linearGradient
          id="paint8_linear_1720_8548"
          x1="70.3142"
          y1="128.175"
          x2="98.1321"
          y2="157.521"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E5E9F0" />
          <stop offset={1} stopColor="#D2DAE8" />
        </linearGradient>
      </defs>
    </svg>
  )
}

export default EmptyIcon
